import { Router } from "express";

import { attendanceController } from "../controllers/attendance-controller";
import { authenticate, createRateLimit } from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";

const router = Router();

// Environment-aware rate limiting
const generalRateLimit = createRateLimit.general();

/**
 * School/Teacher Attendance Routes
 */

/**
 * @route   POST /api/v1/school/attendance
 * @desc    Mark attendance for a class
 * @access  Private (School Admin, Teacher)
 */
router.post(
  "/school/attendance",
  authenticate,
  requireRole(["school", "teacher"]),
  generalRateLimit,
  (req, res) => attendanceController.markAttendance(req, res),
);

/**
 * @route   GET /api/v1/school/attendance
 * @desc    Get attendance for a class
 * @access  Private (School Admin, Teacher)
 */
router.get(
  "/school/attendance",
  authenticate,
  requireRole(["school", "teacher"]),
  generalRateLimit,
  (req, res) => attendanceController.getClassAttendance(req, res),
);

/**
 * @route   GET /api/v1/school/attendance/statistics
 * @desc    Get attendance statistics for a class
 * @access  Private (School Admin, Teacher)
 */
router.get(
  "/school/attendance/statistics",
  authenticate,
  requireRole(["school", "teacher"]),
  generalRateLimit,
  (req, res) => attendanceController.getAttendanceStatistics(req, res),
);

/**
 * Student Mobile App Routes
 */

/**
 * @route   GET /api/v1/student/attendance
 * @desc    Get student's attendance records
 * @access  Private (Student)
 */
router.get(
  "/student/attendance",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => attendanceController.getStudentAttendance(req, res),
);

/**
 * Teacher Mobile App Routes
 */

/**
 * @route   GET /api/v1/teacher/attendance
 * @desc    Get attendance for teacher's classes
 * @access  Private (Teacher)
 */
router.get(
  "/teacher/attendance",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => attendanceController.getTeacherAttendance(req, res),
);

/**
 * @route   POST /api/v1/teacher/check-in
 * @desc    Teacher check-in
 * @access  Private (Teacher)
 */
router.post(
  "/teacher/check-in",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => attendanceController.teacherCheckIn(req, res),
);

/**
 * @route   POST /api/v1/teacher/check-out
 * @desc    Teacher check-out
 * @access  Private (Teacher)
 */
router.post(
  "/teacher/check-out",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => attendanceController.teacherCheckOut(req, res),
);

/**
 * @route   GET /api/v1/teacher/attendance-log
 * @desc    Get teacher's check-in/check-out log
 * @access  Private (Teacher)
 */
router.get(
  "/teacher/attendance-log",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => attendanceController.getTeacherAttendanceLog(req, res),
);

/**
 * @route   GET /api/v1/teacher/students/:studentId/attendance-log
 * @desc    Get student's check-in/check-out log (Teacher view)
 * @access  Private (Teacher)
 */
router.get(
  "/teacher/students/:studentId/attendance-log",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) =>
    attendanceController.getStudentAttendanceLogForTeacher(req, res),
);

/**
 * @route   POST /api/v1/student/check-in
 * @desc    Student check-in for a class
 * @access  Private (Student)
 */
router.post(
  "/student/check-in",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => attendanceController.studentCheckIn(req, res),
);

/**
 * @route   POST /api/v1/student/check-out
 * @desc    Student check-out from a class
 * @access  Private (Student)
 */
router.post(
  "/student/check-out",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => attendanceController.studentCheckOut(req, res),
);

/**
 * @route   GET /api/v1/student/attendance-log
 * @desc    Get student's check-in/check-out log
 * @access  Private (Student)
 */
router.get(
  "/student/attendance-log",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => attendanceController.getStudentAttendanceLog(req, res),
);

/**
 * @route   GET /api/v1/school/students/:studentId/attendance
 * @desc    Get student attendance (School Admin view)
 * @access  Private (School Admin)
 */
router.get(
  "/school/students/:studentId/attendance",
  authenticate,
  requireRole(["school"]),
  generalRateLimit,
  (req, res) => attendanceController.getSchoolStudentAttendance(req, res),
);

export default router;
